/**
 * Created by Arif Topcu in 2019
 */

import SecurityAttributesSelector from './SecurityAttributesSelector';

export default SecurityAttributesSelector;
